export const QA_NAME_POST_STATUS = 'status'

export const QA_NAME_POST_PERIOD = 'period'

export const QA_NAME_POST_TYPE = 'type'
